import { IgnorableNetworkError } from '@/Factories/BookingkitApi/Errors/IgnorableNetworkError';
export class UnAuthenticatedError extends IgnorableNetworkError {
    constructor(...params: any) {
        super(...params);
        this.message = `${this.message}`;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UnAuthenticatedError);
        }

        this.name = 'UnAuthenticatedError';
    }

    static fromUnAuthenticatedRequest():UnAuthenticatedError {
        return new UnAuthenticatedError('This request was unauthorised');
    }
}

export default { UnAuthenticatedError };
